import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { Redirect } from 'react-router'

import Home from '../Home'
import Workspace from '../Workspace'
import LocationSelect from '../LocationSelect'
import SpaceTypeSelect from '../SpaceTypeSelect'
import { ProjectMainView, ProjectListView, ProjectView } from '../Projects'
import ResultsViewLoader from '../Results/ResultsLoader'
import {
  userIsNotAuthenticated,
  userIsAuthenticated
} from '../Shared/routeAuthenticators'

import { withLoadedProject } from '../ProjectLoader'

/* Main routes definition. You *don't* have to define all routes here. It's perfectly
  okay to have further or additional routes in your components. */
export default () => (
  <Route
    render={({ location }) => (
      <Switch location={location}>
        <Route
          exact={true}
          path="/login"
          component={userIsNotAuthenticated(Home)}
        />
        <Route exact={true} path="/" component={Home} />
        <Route exact={true} path="/location" component={LocationSelect} />
        <Route exact={true} path="/spacetype" component={SpaceTypeSelect} />

        <Route
          exact={true}
          path="/recentprojects"
          component={userIsAuthenticated(ProjectMainView)}
        />
        <Route
          exact={true}
          path="/projects"
          component={userIsAuthenticated(ProjectListView)}
        />
        <Route
          path="/project/:projectId"
          render={({ match }) => (
            <Switch>
              <Route
                exact={true}
                path="/project/:projectId"
                render={() => (
                  <Redirect
                    to={`/project/${match.params.projectId}/workspace`}
                  />
                )}
              />
              <Route
                exact={true}
                path="/project/:projectId/details"
                component={userIsAuthenticated(ProjectView)}
              />
              <Route
                exact={true}
                path="/project/:projectId/workspace"
                render={() => withLoadedProject(Workspace)}
              />

              <Route
                path="/project/:projectId/case/:caseId/results/:jobId/:resultId?"
                render={() => withLoadedProject(ResultsViewLoader)}
              />
            </Switch>
          )}
        />
      </Switch>
    )}
  />
)



// WEBPACK FOOTER //
// ./src/Components/Layout/MainRoutes.tsx